<script>
export default {
    name: 'WebsiteLink'
}
</script>
<template>
  <a
    href="https://clinicalgenome.org"
    target="clinicalgenome.org"
  >
    <slot>ClinicalGenome.org</slot>
  </a>
</template>